import React from 'react';
import { Navigate } from 'react-router-dom';
import { getDecodedToken } from '../../services/Token';
import LoginPage from '../login/LoginPage';
import SuperUserDashboard from './SuperUserDashboard';
import AdminDashboard from './AdminDashboard ';

function DashboardRoutes() {
  const decoded = getDecodedToken();

  if (!decoded) {
    return <Navigate to="/login" />;
  }

  if (decoded.rol_id === 1) {
    return <Navigate to="/dashboard/instituciones" />;
  } else if (decoded.rol_id === 2) {
    return <Navigate to="/dashboard/carreras" />;
  } else {
    return <Navigate to="/unauthorized" />;
  }
}

export default DashboardRoutes;
